import React, { useEffect } from 'react'
import Menu from './Menu'
import token from '../assets/token.jpg';
import logo from '../assets/logo.png';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { TwitterTweetEmbed } from 'react-twitter-embed';


export default function Home() {

    useEffect(() => {
        Aos.init({
            duration: 800,
            once: false,
            easing: 'ease',
        });
        Aos.refresh();
    }, [])

    return (
        <div className="bg-black-100 font-inter overflow-hidden text-white-100 -z-10">

            {/* top section */}

            <div className="lg:px-20 px-5 bg-top lg:pb-20 pb-12">
                <div className='container mx-auto'>

                    <Menu />

                    <div className='lg:flex items-center gap-x-12 lg:space-y-0 space-y-12 py-8'>

                        <div data-aos='fade-up' className='lg:w-1/2'>
                            <TwitterTweetEmbed tweetId="1702472560183521435" />
                        </div>

                        <div data-aos='fade-right' className='lg:flex items-center gap-x-24 lg:mt-12 mt-6 lg:space-y-0 space-y-6'>

                            <div className='space-y-2'>
                                <h5 className='lg:text-2xl text-xl font-bold'>Ethereum ERC20</h5>
                                <p className='text-white-50 font-medium'>Built On Ethereum Network</p>
                            </div>

                            <div className='space-y-2'>
                                <h5 className='lg:text-2xl text-xl font-bold'>$GAI</h5>
                                <p className='text-white-50 font-medium'>Token Symbol/Ticker.</p>
                            </div>

                        </div>
                    </div>

                    <h1 data-aos='zoom-in' className='lg:py-16 lg:text-8xl text-5xl font-black'>
                        THE <span className='text-blue-50'>GEMINI</span> AI
                    </h1>

                    <div className='lg:flex items-center justify-between lg:space-y-0 space-y-12'>
                        <div className='lg:w-1/2'>
                            <p data-aos='fade-right' className='lg:leading-loose'>
                                Join the GEMINI AI, learn, earn and ride the surging AI. Follow GOOGLE and their upcoming launches - the AI mission.
                            </p>

                            <p data-aos='fade-right' className='lg:leading-loose pt-6'>
                                JUST IN: Google $GOOGL is reportedly nearing the release of Gemini AI its rival to OpenAI's ChatGPT-4 Google has given a small group of outside companies access to an early version of its conversational AI signaling its getting close to incorporating it into its consumer services and selling it to businesses through the company’s cloud unit
                            </p>
                        </div>

                        <div>
                            <a data-aos='zoom-in' href='https://app.uniswap.org/#/swap?outputCurrency=0x01D182420a501e29C31D41bBCC7a25A4200d1535'>
                                <button className='bg-black-100 text-blue-50 rounded-full uppercase lg:text-xl font-bold px-8 py-4 hover:bg-blue-50 hover:text-black-100 flex items-center gap-x-4'>
                                    buy on uniswap
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                                    </svg>
                                </button>
                            </a>

                        </div>
                    </div>


                </div>
            </div>

            {/* tokenomics section */}

            <div id='tokenomics' className="lg:px-20 px-5 bg-black-200">
                <div className='container mx-auto'>

                    <div className="lg:flex block justify-between items-center gap-x-24 lg:py-16 py-6 lg:space-y-0 space-y-12">

                        <div data-aos='fade-right' className='lg:w-1/2'>
                            <img src={token} alt='tokenomics'></img>
                        </div>

                        <div data-aos='fade-left' className='space-y-8 lg:w-1/2'>
                            <button className='border border-black-50 rounded-full px-5 py-2 uppercase flex items-center gap-x-4 text-blue-50'>
                                TOKEN DETAILS
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="w-4 h-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                                </svg>
                            </button>

                            <h2 className='lg:text-6xl text-3xl font-bold'>
                                Discover Our
                            </h2>

                            <h2 className='lg:text-6xl text-3xl font-bold text-blue-50'>
                                Tokenomics
                            </h2>

                            <p>
                                Google, one of the billion company launching a new AI rival to Open AI. Never missed the chance to ride the surging AI.
                            </p>

                            <p>
                                CA: 0x01D182420a501e29C31D41bBCC7a25A4200d1535
                            </p>

                            <p>
                                Learn more about our tokenomics below:
                            </p>


                            <div>
                                <a href='https://etherscan.io/token/0x01d182420a501e29c31d41bbcc7a25a4200d1535'>
                                    <button className='border border-blue-50 text-blue-50 rounded-full px-8 py-4 hover:bg-blue-50 font-bold hover:text-black-100'><a href="https://t.me/GeminiAI_ERC" className="uppercase">check on etherscan</a></button>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id='tokenomics' className="lg:px-20 px-5 lg:py-20 py-6">
                <div className='container mx-auto'>

                    <div className='absolute left-0 right-0 lg:-mt-44 -mt-16'>
                        <marquee >
                            <div className='flex items-center gap-x-3'>
                                <p className='lg:text-8xl text-2xl font-black hover:text-blue-50 uppercase'>gemini ai ($gai)</p>
                                <p className='lg:text-8xl text-2xl font-black uppercase text-outline'>gemini ai ($gai)</p>
                                <p className='lg:text-8xl text-2xl font-black uppercase hover:text-blue-50'>gemini ai ($gai)</p>
                                <p className='lg:text-8xl text-2xl font-black uppercase text-outline'>gemini ai ($gai)</p>
                            </div>
                        </marquee>
                    </div>

                    <div className='lg:flex items-center justify-between lg:mt-44 mt-16 lg:space-y-0 space-y-12'>
                        <div data-aos='fade-right' className='lg:w-1/2 space-y-8'>

                            <div>
                                <a href="/" className="flex items-center gap-2 group">
                                    <img src={logo} alt="Logo" className='w-12' />
                                    <p className='font-semibold group-hover:text-blue-50'>GAI</p>
                                </a>
                            </div>

                            <p>
                                Join our awesome community and learn more about the<br></br> project's goal and milestones.
                            </p>

                            <div>
                                <a href='mailto:info@geminiai-coin.com' className='text-blue-50 lg:text-2xl text-l font-semibold'>
                                    info@geminiai-coin.com
                                </a>
                            </div>

                        </div>

                        <div className='flex items-center justify-center lg:gap-x-12 gap-x-6'>

                            <button data-aos='flip-right' className='border border-black-50 rounded-full lg:px-8 px-5 lg:py-5 py-3 group'><a href="https://x.com/geminiai_erc?s=21&t=AAeulnrJ8097JIfGWHF2cQ" className="flex items-center lg:gap-x-8 gap-x-5">

                                <span className='w-8 h-8 bg-social rounded-full flex items-center justify-center p-3'>
                                    <i className='fa fa-twitter'></i>
                                </span>

                                Twitter
                            </a>
                            </button>

                            <button data-aos='flip-left' className='border border-black-50 rounded-full lg:px-8 px-5 lg:py-5 py-3 group'><a href="https://t.me/GeminiAI_ERC" className="flex items-center lg:gap-x-8 gap-x-5">

                                <span className='w-8 h-8 bg-social rounded-full flex items-center justify-center p-3'>
                                    <i className='fa fa-telegram'></i>
                                </span>

                                Telegram
                            </a>
                            </button>

                        </div>
                    </div>



                </div>


            </div>

            <div id='' className="lg:px-20 px-5 py-12 border-t border-black-50">
                <div className='container mx-auto'>

                    <div className=''>
                        <p className=''>Copyright © {new Date().getFullYear()}  GEMINI AI . All Rights Reserved</p>
                    </div>
                </div>

            </div >
        </div>
    )
}
